import { render, staticRenderFns } from "./journal-v2.vue?vue&type=template&id=7b64c8ca"
import script from "./journal-v2.vue?vue&type=script&lang=js"
export * from "./journal-v2.vue?vue&type=script&lang=js"
import style0 from "./journal-v2.vue?vue&type=style&index=0&id=7b64c8ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports